import { render, staticRenderFns } from "./KnowUSoon.vue?vue&type=template&id=e1217c88&scoped=true&lang=pug"
import script from "./KnowUSoon.vue?vue&type=script&lang=js"
export * from "./KnowUSoon.vue?vue&type=script&lang=js"
import style0 from "./KnowUSoon.vue?vue&type=style&index=0&id=e1217c88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1217c88",
  null
  
)

export default component.exports